import { render, staticRenderFns } from "./PanelWithMaterialPurchaseOrderEditor.vue?vue&type=template&id=5390c56c&lang=pug&"
import script from "./PanelWithMaterialPurchaseOrderEditor.vue?vue&type=script&lang=ts&"
export * from "./PanelWithMaterialPurchaseOrderEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PanelWithMaterialPurchaseOrderEditor.vue?vue&type=style&index=0&id=5390c56c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports